export default {
  时间: 'Time',
  新建: 'Add',
  编辑: 'Edit',
  删除: 'Delete',
  保存: 'Save',
  取消: 'Cancel',
  确定: 'OK',
  关闭: 'Close',
  搜索: 'Search',
  刷新: 'Refresh',
  更多: 'More',
  关联: 'Related',
  评论: 'Comments',
  法人: 'Legal person',
  省份: 'Province',
  公司: 'Company',
  律所: 'Law firm',
  序号: 'Serial number',
  已选: 'Selected',
  读写: 'Read-write',
  只读: 'Read-only',
  姓名: 'Name',
  权限: 'Permissions',
  回复: 'Reply',
  对象: 'Object',
  作废: 'Invalid',
  群名称: 'Group name',
  群成员: 'Group members',
  基金会: 'Foundation',
  新机构: 'New institution',
  未生效: 'Not in effect',
  已生效: 'In effect',
  已接通: 'Connected',
  未接通: 'Not connected',
  创建人: 'Creator',
  已结束: 'Ended',
  负责人: 'Person in charge',
  协作人: 'Co-operators',
  注册号: 'Registration number',
  拨打人: 'Caller',
  转化人: 'Transformer',
  联系人: 'Contact',
  接收人: 'Recipient',
  日程主题: 'Schedule topic',
  转化时间: 'Conversion time',
  转移原因: 'Reason for transfer',
  文件名称: 'File name',
  来源模块: 'Source module',
  文件类型: 'File type',
  事业单位: 'Institutions',
  社区组织: 'Community organizations',
  详情附件: 'Details attachment',
  香港公司: 'Hong Kong company',
  机构类型: 'Institutional type',
  注册资金: 'Registered Capital',
  注册资本: 'Registered funds',
  成立日期: 'Establishment date',
  是否KDM: 'Whether KDM',
  联系电话: 'Contact phone',
  群组名称: 'Group name',
  妙记链接: 'Brilliant record link',
  新建日程: 'New schedule',
  会议妙记: 'Meeting minutes',
  编辑日程: 'Edit schedule',
  添加跟进: 'Add follow-up',
  动态记录: 'Follow-up records',
  取消评论: 'Cancel comment',
  上传附件: 'Upload an Attachment',
  本地附件: 'Local attachment',
  附件类型: 'Attachment type',
  支持上传: 'Support for upload',
  等格式的文件: 'Format files',
  格式的文件: 'Format files',
  复制成功: 'Copy success',
  删除成功: 'Deleted successfully',
  编辑跟进: 'Edit follow-up',
  新增成功: 'Added successfully',
  确认删除: 'Confirm deletion',
  创建群组: 'Create a group',
  创建失败: 'Creation failed',
  创建成功: 'Create successfully',
  添加成功: 'Add success',
  添加失败: 'Add failure',
  拨打时间: 'Calling time',
  应答时间: 'Answering Time',
  结束时间: 'End time',
  通话时长: 'Call duration',
  跟进建议: 'Follow-up suggestions',
  跟进详情: 'Follow-up details',
  线索渠道: 'Clue channel',
  成交状态: 'Deal status',
  客户名称: 'Customer name',
  我方参会人: 'Our attendees',
  客户参会人: 'Customer attendees',
  业绩参与人: 'Performance participants',
  线索跟进人: 'Clue follower',
  添加联系人: 'Add contacts',
  新增云文档: 'New cloud document',
  联系人职位: 'Contact position',
  新增联系人: 'Add new contacts',
  编辑联系人: 'Edit contact',
  联系人拨打: 'Contact call',
  已完成日程: 'Completed schedule',
  未完成日程: 'Unfinished schedule',
  未发现客户: 'Customer not found',
  数据加载中: 'Data loading',
  管理协作人: 'Manage collaborators',
  新增协作人: 'Add collaborators',
  数据保存中: 'Data saving',
  云文档链接: 'Cloud document link',
  云文档类型: 'Cloud document type',
  老板委派调研人: 'Boss delegate researcher',
  组织机构代码: 'Organization code',
  暂无沟通记录: 'No communication record yet',
  创建群组失败: 'Failed to create group',
  关联客户信息: 'Related customer information',
  获取数据失败: 'Failed to get data',
  添加动态记录: 'Add follow-up record',
  暂无通话记录: 'No call records yet',
  编辑动态记录: 'Edit follow-up record',
  下次跟进时间: 'Next follow-up time',
  下次跟进方式: 'Next follow-up method',
  下次参会人员: 'Participants next time',
  请选择下次参会人员: 'Please select participants for next time',
  单次上传最多支持: 'Single upload supports up to',
  个文件: 'Files',
  文件类型无限制: 'No limit on file type',
  字段同步: 'Field Synchronization',
  新增协作人失败: 'Failed to add collaborators',
  编辑协作人失败: 'Failed to edit collaborators',
  协作人查询异常: 'Cooperator query exception',
  已添加动态记录: 'Added following record',
  暂无已完成日程: 'No completed schedule yet',
  请选择是否KDM: 'Please choose whether KDM',
  设为默认联系人: 'Set as default contact',
  请输入评论内容: 'Please input the comment content',
  联系人所在部门: 'Contact department',
  审批中的订单不可作废: 'Orders under approval cannot be voided',
  审批中的报价单不可作废: 'Quotations under approval cannot be voided',
  跟进详情是必填项: 'Follow-up details are required',
  请填写联系人姓名: 'Please fill in the contact name',
  请选择联系人职位: 'Please choose the contact position',
  统一社会信用代码: 'Unified social credit code',
  获取客户协作权限失败: 'Fail to get customer cooperation permissions',
  下次跟进时间为必填项: 'The next follow-up time is required',
  请填写联系人所在部门: 'Please fill in the contact department',
  动态记录数据获取失败: 'Failed to get the follow-up record data',
  '确认删除此节点？': 'Confirm to delete this node?',
  '暂无日程，可新建日程': 'No schedule, can create new schedule',
  '确认移除该日程？': 'Confirm to remove this schedule?',
  '上传失败,请上传支持的文件类型': 'Upload failed, please upload the supported file type',
  '文件已存在，无需重复上传': 'File already exists, no need to upload again',
  '上传失败,文件大小不能超过50M': 'Upload failed, file size cannot exceed 50M',
  请选择跟进方式: 'Please select a follow-up method',
  '请选择人员，仅支持选择租户内人员': 'Please select personnel, only support to select tenants',
  跟进时间是必填项: 'Follow-up time is a required field',
  跟进方式是必选项: 'Follow-up method is a required field',
  '输入人员名称，如有多人以，分割': 'Enter the name of the personnel, if there are multiple people, split with,',
  请填写会议妙记链接: 'Please fill in the meeting minutes link',
  下次跟进方式是必选项: 'Next follow-up method is a required option',
  请选择下次跟进方式: 'Please choose next follow-up method',
  值: 'Value',
  其他: 'Other',
  规则: 'Rule',
  添加: 'Add',
  筛选: 'Filter',
  清除: 'Clear',
  重复: 'Repeat',
  请修改: 'Please Modify',
  列选择: 'Column Selection',
  全部数据: 'All Data',
  提示信息: 'Tip Information',
  插入变量: 'Insert Variable',
  查重条件: 'Duplication Check Condition',
  精准匹配: 'Exact Match',
  模糊匹配: 'Fuzzy Match',
  更新成功: 'Update Successful',
  更新失败: 'Update Failed',
  基础字段: 'Basic Field',
  当前默认: 'Current Default',
  设为默认: 'Set as Default',
  恢复默认: 'Restore Default',
  拖到这里: 'Drag Here',
  类型的筛选: 'Type Filter',
  值不能为空: 'Value Cannot be Empty',
  已添加的列: 'Added Column',
  可选择的列: 'Selectable Column',
  请选择抬头类型: 'Please Select Title Type',
  请输入开票抬头: 'Please Enter Invoice Title',
  请输入纳税识别号: 'Please Enter Tax Identification Number',
  请选择参与人角色: 'Please Select Participant Role',
  请选择协作阶段: 'Please Select Collaboration Stage',
  请输入绩效比例: 'Please Enter Performance Ratio',
  请选择附件类型: 'Please Select Attachment Type',
  请上传本地附件: 'Please Upload Local Attachment',
  请输入云文档链接: 'Please Enter Cloud Document Link',
  请选择云文档类型: 'Please Select Cloud Document Type',
  请输入正确的手机号: 'Please Enter Correct Mobile Number',
  请输入员工手机号: 'Please Enter Employee Mobile Number',
  请选择外呼中间号: 'Please Select Outbound Middle Number',
  请查找或选择号码: 'Please Search or Select Number',
  请选择默认号码: 'Please Select Default Number',
  请选择部门和人员: 'Please Select Department and Personnel',
  请填写手机号: 'Please Fill in Mobile Number',
  搜索员工姓名: 'Search Employee Name',
  请输入提示信息: 'Please Enter Tip Information',
  筛选数据不完整: 'Filter Data Incomplete',
  请输入选项名称: 'Please Enter Option Name',
  请输入选项值: 'Please Enter Option Value',
  字段类型为必选项: 'Field Type is Required',
  请选择字段类型: 'Please Select Field Type',
  选项数据名称: 'Option Data Name',
  选项选项值: 'Option Option Value',
  设置选项为必填项: 'Set Option as Required',
  选项key值为必填项: 'Option Key Value is Required',
  转化为客户商机: 'Convert to Customer Opportunity',
  请填写评论内容: 'Please Fill in Comment Content',
  请输入群名称: 'Please Enter Group Name',
  请输入备注: 'Please Enter Remarks',
  会议状态: 'Meeting Status',
  请输入key值: 'Please Enter Key Value',
  我的外呼设置: 'My Outbound Setting',
  外呼设置: 'Outbound Setting',
  外呼系统工号: 'Outbound System Number',
  外呼系统角色: 'Outbound System Role',
  外呼拨打号码: 'Outbound Dial Number',
  请输入详细地址: 'Please Enter Detailed Address',
  请选择地址类型: 'Please Select Address Type',
  请输入邮政编码: 'Please Enter Postal Code',
  请输入字段名称: 'Please Enter Field Name',
  请输入数据条件: 'Please Enter Data Condition',
  请选择视图: 'Please Select View',
  请选择视图类型: 'Please Select View Type',
  请选择日期范围: 'Please Select Date Range',
  请填写规则名称: 'Please Fill in Rule Name',
  请选择数据对象: 'Please Select Data Object',
  请输入开户银行: 'Please Enter Opening Bank',
  请输入开户账号: 'Please Enter Account Number',
  请输入开票地址: 'Please Enter Invoice Address',
  请输入部门名称: 'Please Enter Department Name',
  请输入姓名搜索: 'Please Enter Name Search',
  请输入规则名称: 'Please Enter Rule Name',
  请填写跟进详情: 'Please Fill in Follow-up Details',
  请选择协作人: 'Please Select Collaborator',
  请输入一级选项名称: 'Please Enter First-Level Option Name',
  请输入二级选项名称: 'Please Enter Second-Level Option Name',
  请输入三级选项名称: 'Please Enter Third-Level Option Name',
  请输入新建的角色名: 'Please Enter New Role Name',
  请输入修改的角色名: 'Please Enter Modified Role Name',
  请选择权限: 'Please Select Permission',
  只能选择一个接收人: 'Only One Recipient Can be Selected',
  请填写转移原因: 'Please Fill in Transfer Reason',
  接收线索池: 'Receive Clue Pool',
  请选择接收线索池: 'Please select the receiving thread pool',
  退回原因: 'Reason for return',
  请填写退回原因: 'Please fill in the reason for return',
  变更其他负责人: 'Change of other responsible persons',
  请选择变更其他负责人: 'Please select Change to another person in charge',
  员工个人手机号: 'Employee Personal Mobile Number',
  请选择对接产品线: 'Please choose the product line to dock',
  请选择对接人角色: 'Please choose the role of the docking person',
  请选择对接人职位: 'Please choose the position of the docking person',
  请选择所在部门: 'Please choose the department',
  请选择对接人态度: 'Please choose the attitude of the docking person',
  请填写补充信息: 'Please fill in the supplementary information',
  请选择日期: 'Please select a date',
  通话状态: 'Call status',
  请选择通话时长: 'Please select the call duration',
  请选择客户规模: 'Please select the customer size',
  行业: 'Industry',
  请选择行业: 'Please select an industry',
  日程状态: 'Schedule status',
  请选择日程状态: 'Please select a schedule status',
  日程未开始: 'Schedule not started',
  日程进行中: 'Schedule in progress',
  日程已结束: 'Schedule ended',
  全量线索: 'Full lead',
  建议转化线索: 'Suggested conversion lead',
  有效线索数: 'Valid Clue Number',
  线索跟进率: 'Clue Follow-up Rate',
  请选择通话状态: 'Call status Translation',
  通话详情: 'Call details',
  日程详情: 'Schedule details',
  请选择状态: 'Please choose a status',
  线下拜访: 'Offline visit',
  线上: 'Online',
  无: 'None',
  通话总数: 'Total calls',
  对象Id不能为空: 'The object ID cannot be empty',
  选择关联: 'Select Associate',
  审批中: 'Approval',
  请输入名称: 'Please enter the name',
  '请选择/输入值搜索': 'Please select / enter value for search',
  报价单产品: 'Quotation products',
  合同: 'Contract',
  合同产品: 'Contract products',
  订单: 'Order',
  订单产品: 'Order products',
  售后: 'After sales',
  请选择部门或人员: 'Please select a department or personnel',
  开始时间: 'Start time',
  下级: 'subordinate',
  火山设置: 'Volcengine Settings',
  应用凭证: 'Apply credentials',
  开发文档: 'Development documentation',
  '0~1分钟': '0~1 Minute',
  '1~5分钟': '1~5 Minutes',
  '5~20分钟': '5~20 Minutes',
  '20~30分钟': '20~30 Minutes',
  '30分钟以上': 'More than 30 Minutes',
  首电沟通: 'First Call Communication',
  电话沟通: 'Telephone Communication',
  '飞书/微信沟通': 'Feishu/WeChat Communication',
  线上Pitch: 'Online Pitch',
  走进字节: 'Into ByteDance',
  正式会议: 'Official Meeting',
  '外部活动/会议': 'External Activities/Meetings',
  '喝茶/喝咖啡': 'Drinking Tea/Coffee',
  饭局: 'Dinner',
  来华映参访: 'Visit Huaying',
  去对方拜访: 'Visit the other party',
  '线上会议/电话/微信': 'Online Meeting/Call/WeChat',
  '外部情报（未直接与对方联系）': 'External Information (No Direct Contact with the Party)',
  等于: 'Equals',
  不等于: 'Not Equal To',
  包含: 'Contains',
  不包含: 'Does Not Contain',
  为空: 'Is Null',
  不为空: 'Is Not Null',
  单行文本: 'Single-line Text',
  多行文本: 'Multiple-line Text',
  单选按钮: 'Radio Button',
  多选按钮: 'Checkbox',
  下拉单选: 'Drop Down Single Selection',
  下拉多选: 'Drop Down Multi Selection',
  数字: 'Number',
  日期: 'Date',
  日期范围: 'Date Range',
  超链接: 'Hyperlink',
  查找关联: 'Search and Link（Single）',
  '查找关联(多选)': 'Search and Link（Multi-select）',
  自增编码: 'Auto-increment Coding',
  金额: 'Amount',
  附件: 'Attachment',
  部门: 'department',
  明细: 'Detail',
  教师: 'Teacher',
  学生: 'Student',
  设计负责人: 'Design Lead',
  工程师: 'Engineer',
  '法人/CEO/老板': 'Legal Person/CEO/Boss',
  总经理: 'General Manager',
  运营主管: 'Operations Supervisor',
  IT主管: 'IT Head',
  技术负责人: 'Technical Lead',
  市场主管: 'Marketing Head',
  首席数据官: 'Chief Data Officer',
  财务主管: 'Finance Head',
  '副总裁/高级副总裁': 'Vice President/Senior Vice President',
  '总监/高级总监': 'Director/Senior Director',
  '经理/高级经理': 'Manager/Senior Manager',
  普通员工: 'Ordinary Employee',
  人事负责人: 'HR Head',
  销售主管: 'Sales Supervisor',
  行政主管: 'Administration Supervisor',
  业务主管: 'Business Supervisor',
  产品负责人: 'Product Manager',
  董事长: 'Chairman',
  投资总监: 'Investment Director',
  投资经理: 'Investment Manager',
  秘书: 'Secretary',
  其他管理层岗位: 'Other Management Positions',
  其他执行层岗位: 'Other Executive Positions',
  咨询顾问: 'Consultant',
  商务: 'Business',
  售前: 'Pre-sales',
  '意向沟通(20%)': 'Intention Communication (20%)',
  '商机确认(20%)': 'Business Opportunity Confirmation (20%)',
  '方案沟通(30%)': 'Solution Communication (30%)',
  '商务谈判(20%)': 'Business Negotiation (20%)',
  '客户签约(10%)': 'Customer Contract Signing (10%)',
  注册地址: 'Registered Address',
  办公地址: 'Office Address',
  仓储地址: 'Warehouse Address',
  门店地址: 'Store Address',
  家庭地址: 'Home Address',
  单位: 'Unit',
  '编辑/删除联系人': 'Edit/delete contacts',
  附件内容: 'Attachment Content',
  请选择附件内容: 'Please select the content in the attachment',
  所在城市: 'Current City',
  请选择所在城市: 'Please select your current city',
  个人重要性: 'Personal Importance',
  请选择个人重要性: 'Please select your personal importance',
  微信号: ' WeChat ID',
  请填写微信号: 'Please enter your WeChat ID',
  邮箱: 'Email',
  请填写邮箱: 'Please enter your Email',
  详细地址: 'Detailed Address',
  请填写详细地址: 'Please enter your Detailed Address',
  个人简介: 'Personal Biography',
  请填写个人简介: 'Please fill out your personal biography',
  非常重要: ' Very important',
  较重要: 'Moderately important',
  一般: 'General',
  未知: 'Unknown',
  添加其他协作人: 'Add other collaborators',
  加入群组: 'Join a group',
  拨打时长: 'Call duration',
  通话已接通: 'Call connected',
  通话未接通: 'Call not connected',
  审批中的退货单不可转移: 'Approval pending return orders cannot be transferred',
  审批中的退货单不可作废: 'Approval pending return orders cannot be invalidated',
  '系统开小差了，请过后重试': 'The system has deviated. Please try again later',
  '文件上传未完成,请重新上传': 'The file upload is not complete, please upload again!',
  '该名称已存在，当前无负责人': 'The name already exists and there is currently no responsible person',
  '该名称已存在，当前负责人为': 'The name already exists and the current person in charge is',
  我方参会人是必选项: 'Our participants are a must',
  客户参会人是必选项: 'Customer participants are required',
  请填写备注: 'Please fill in the remarks',
  备注: 'Remarks',
  设置原负责人为协作人: 'Set the original owner as the collaborator',
  文档: 'Document',
  计算公式: 'Calculation Formula',
  图片: 'Picture',
  图片V2: 'Picture V2',
  地址: 'Address',
  职位: 'Position',
  暂无查看权限: 'No view permission',
  复制链接: 'Copy Link',
  链接已复制到剪贴板: 'The link has been copied to the clipboard',
  复制失败: 'Copy failed',
  多维表格在当前页面环境无法正常登录: 'Multidimensional tables cannot log in normally in the current page environment',
  点击按钮前往查看: 'Click the button to view',
  查看: 'View',
  没有找到匹配的数据: 'No matching data found',
  最多上传: 'Maximum uploads',
  列表新功能引导: 'List new feature guide',
  点击进行预览: 'Click to preview',
  列表数据模糊搜索: 'List data fuzzy search',
  '列表需支持全量数据模糊搜索及指定字段类型的模糊搜索，以满足不同场景下的数据查询需求。': 'List needs to support full data fuzzy search and fuzzy search of specified field types to meet the data query needs of different scenarios.',
  双击进入快捷编辑: 'Double click to enter quick editing',
  '需实现双击列表对应数据单元格直接进入编辑状态的功能，支持在列表内完成数据维护。': 'Need to implement the function of double-clicking the corresponding data cell in the list to enter the editing status and support data maintenance in the list.',
  操作列入口调整: 'Operation column entry adjustment',
  '操作列需取消右侧固定悬浮样式，调整为勾选数据后在屏幕下方显示操作入口，优化界面空间使用及操作体验。': 'The operation column needs to cancel the right floating style on the right side and adjust it to show the operation entry after selecting the data on the screen, optimizing the interface space usage and operation experience.',
  '当前登录账号身份已变更，请刷新后重试': 'Your login account identity has been changed. Please refresh and try again',
  无符合条件的数据: 'No data that meets the criteria'
};
